import React from 'react';
import { sundayBeats } from '../data/copy';
export function ProblemSection() {
  return <section className="w-full bg-sand py-12 sm:py-16" aria-labelledby="problem-heading" data-id="element-167" data-mp="2lstl5l3i8ih6">
      <div className="mx-auto max-w-5xl px-6" data-id="element-168" data-mp="30hpmz0eywz9c">
        <div className="grid items-center gap-8 lg:grid-cols-[0.8fr_1.2fr] lg:gap-14" data-id="element-169" data-mp="30iirrvud9eou">
          {/* The clock is the whole argument: your evening, already gone. */}
          <div className="rounded-4xl bg-indigo-deep px-8 py-10 text-center" data-id="element-170" data-mp="39guqkl5dzisd">
            <p className="font-sans text-[11px] font-semibold uppercase tracking-[0.28em] text-gold-soft" data-id="element-171" data-mp="35gtz9zx6vd3w">
              Sunday
            </p>
            <p className="mt-3 font-display text-[4rem] leading-none text-ivory sm:text-[4.5rem]" data-id="element-172" data-mp="3jfagwlwlao0t">
              10:00
            </p>
            <p className="mt-1 font-display text-2xl tracking-[0.2em] text-ivory/70" data-id="element-173" data-mp="1p2152ngkmqfe">
              PM
            </p>
            <p className="mx-auto mt-6 max-w-[14rem] border-t border-ivory/15 pt-5 font-sans text-[0.8rem] leading-relaxed text-ivory/70" data-id="element-174" data-mp="1k3hdo7j7kmfn">
              Your art class is tomorrow morning.
            </p>
          </div>

          <div data-id="element-175" data-mp="od9g06e122ak">
            <h2 id="problem-heading" className="font-display text-[2rem] leading-[1.1] text-ink sm:text-[2.6rem]" data-id="element-176" data-mp="ocpxookgtbw0">
              And you’re{' '}
              <span className="text-terracotta" data-id="element-177" data-mp="x5bg23k6pgkb">still at the table.</span>
            </h2>

            <ul className="mt-7 space-y-3.5 border-l-2 border-terracotta/40 pl-5" data-id="element-178" data-mp="122jrllatumcl">
              {sundayBeats.map(beat => <li key={beat} className="font-sans text-[0.95rem] leading-snug text-stone sm:text-base" data-id="element-179" data-mp="170v1fw14gwut">
                  {beat}
                </li>)}
            </ul>

            <p className="mt-8 font-display text-xl leading-snug text-ink sm:text-2xl" data-id="element-180" data-mp="3dtfb0b9xrntb">
              You already know art.{' '}
              <span className="text-terracotta-deep" data-id="element-181" data-mp="3hvse0rxat7me">
                What nobody ever handed you was the system.
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}